import React, { HtmlHTMLAttributes, InputHTMLAttributes, useState, useRef, MutableRefObject, ReactNode, useEffect } from "react";
import { makeStyles, Theme, createStyles, Button, withStyles, ButtonProps, FormControl, FormHelperText } from '@material-ui/core';


// style----------------------------------------------------
export const StyleFormControl = withStyles(({ palette, }) => ({
    root: {
        padding: "5px",
    },
}))(FormControl);

const useStyles = makeStyles((theme) => createStyles({
    root: {
        backgroundColor: theme.palette.primary.main,
        color: "white",
        padding: "6px 16px",
        fontSize: "0.875rem",
        minWidth: "64px",
        boxSizing: "border-box",
        transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontWeight: 500,
        lineHeight: 1.75,
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        boxShadow: "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
        "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
        }
    },
}));

export const StyledSpanButton = props => {
    const classes = useStyles();
    return <span className={classes.root}>{props.text} </span >
}

export const StyleFormHelperText = withStyles(({ palette, }) => ({
    root: {
        margin: "5px 14px 0",
    }
}))(FormHelperText);







const Style_Button = withStyles({
    root: {
        borderRadius: "20px",
    }
})(Button)

export const ButtonContain = (props) => {
    const { children, ...other } = props
    return <Style_Button variant="contained" color="primary" {...other}>{children}</Style_Button>
}
export const ButtonContainO = (props) => {
    const { children, ...other } = props
    return <Button variant="contained" color="primary" {...other}>{children}</Button>
}
export const ButtonOutline = (props) => {
    const { children, ...other } = props
    return <Button variant="outlined" color="primary" {...other}>{children}</Button>
}